// src/components/DataTabHeading.jsx
//
// ADMIN-DATA-TABS-FIX — unified sub-heading for all Admin → Data tab sections.
//
// Deliberately has NO blue accent bar. PaneHeading (with the blue bar) is
// reserved for primary panel headings outside the Data tabs. This component
// is the single source of truth for headings inside Health, Ingestion history,
// Import, Export, and Maintenance.
//
// Props
//   children — heading label (string or JSX)
//   description — optional muted description line rendered below the heading
//   style       — optional overrides applied to the outer wrapper div

import React from "react";
import { T } from "../app/tokens.js";

export function DataTabHeading({ children, description, style }) {
  return (
    <div style={{ marginBottom: description ? 4 : 12, ...style }}>
      <div
        style={{
          fontSize:   T.fsMd,
          fontWeight: T.fwBold,
          color:      T.dark,
          lineHeight: 1.3,
        }}
      >
        {children}
      </div>
      {description && (
        <div
          style={{
            fontSize:   T.fsSm,
            color:      T.mid,
            marginTop:  3,
          }}
        >
          {description}
        </div>
      )}
    </div>
  );
}
